import { useMutation } from "@apollo/client";
import { UPDATE_CATEGORY } from "../graphql/category";
import { useState } from "react";
import { toast } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { ExpenseCategory } from "../components/common/CategorySearchAutoComplete";

export const useUpdateCategories = (accountCategories: ExpenseCategory[]) => {
  const { t } = useTranslation();
  const [updateCategory] = useMutation(UPDATE_CATEGORY);
  const [selectedItems, setSelectedItems] = useState<{
    [key: string]: ExpenseCategory;
  }>({});

  const updateCategories = async () => {
    const dataToSend = Object.keys(selectedItems).map((categoryId) => {
      const accountCategory = selectedItems[categoryId];
      const accountCategoryId = accountCategory.id;
      const accountCategoryName = accountCategory.name;

      return {
        categoryId,
        accountCategoryId,
        accountCategoryName,
      };
    });

    for (const item of dataToSend) {
      try {
        await updateCategory({
          variables: {
            id: item.categoryId,
            input: {
              accountCategory: item.accountCategoryName,
              accountCategoryId: item.accountCategoryId,
            },
          },
        });

        toast.success(t("Category updated successfully"));
      } catch (error: any) {
        toast.error(t("Failed to update category") + ": " + error.message);
      }
    }

    setSelectedItems({});
  };

  return { selectedItems, setSelectedItems, updateCategories };
};
